import { Link, useRouteError } from 'react-router';
import { errorMessage } from '../lib/errorMessage';
import { isChunkLoadError } from '../lib/chunkError';

// Router-level error boundary (errorElement). Replaces react-router's default
// unstyled "Unexpected Application Error!" page with the NotFound-style chrome and
// a recovery affordance: a chunk-load failure gets a Reload button (the no-cache
// index.html revalidates and picks up the new asset graph), anything else gets a
// back-to-jobs link plus the error message for debuggability.
export function RouteError() {
  const error = useRouteError();

  if (isChunkLoadError(error)) {
    return (
      <div className="p-8 text-center">
        <p className="text-sm font-semibold uppercase tracking-wide text-slate-500">
          Update available
        </p>
        <h1 className="mt-2 text-lg font-semibold text-slate-900">A new version was deployed</h1>
        <p className="mt-2 text-sm text-slate-600">
          This page&apos;s code was replaced by a newer build. Reload to continue.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-4 inline-block rounded border border-slate-300 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 hover:border-slate-400"
        >
          Reload
        </button>
      </div>
    );
  }

  return (
    <div className="p-8 text-center">
      <p className="text-sm font-semibold uppercase tracking-wide text-slate-500">Error</p>
      <h1 className="mt-2 text-lg font-semibold text-slate-900">Something went wrong</h1>
      <p className="mt-2 text-sm text-slate-600">
        An unexpected error occurred while rendering this page.
      </p>
      <p className="mt-2 font-mono text-xs text-slate-400">{errorMessage(error)}</p>
      <Link to="/" className="mt-4 inline-block text-sm text-blue-600 underline">
        Back to jobs
      </Link>
    </div>
  );
}
